<template>
    <div>
        <ButtonSelectField
            :customErrorMessage="$t('form.fields.employmentIndustry.errorMessage')"
            :multiple="multiple"
            :name="name"
            :options="options"
            :validationRules="validationRules"
            @input="inputSelected"
            buttonClasses="wizard-button"
        />
    </div>
</template>
<script>
import { useStore } from 'vuex'

// lodash components
import forEach from 'lodash/forEach'

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'employmentIndustry',
            hideContinue: true,
            route: {
                relativeUrl: `sektor-zatrudnienia`,
                name: 'apply.employment.industry',
                meta: {
                    title: 'form.sections.employment.industry',
                },
            },
            fields: {
                employmentIndustry: {
                    value: null,
                    mappedKey: 'employer_industry',
                    validationRules: {
                        required: true,
                    },
                },
            },
        }
    },

    data() {
        return {
            name: 'employmentIndustry',
            loading: false,
            multiple: false,
            validationRules: {
                required: true,
            },
            options: [],
        }
    },
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    created() {
        this.emitter.emit('stepLoaded')
    },
    mounted() {
        let industries = this.$i18n.messages[this.$i18n.locale].form.fields.employmentIndustry.options

        if (industries) {
            forEach(industries, (value, key) => {
                this.options.push({
                    value: value.value,
                    name: value.name,
                    ref: key + value.name,
                })
            })
        }

        this.emitter.on('autocompleteField:selected', () => {
            this.emitter.emit('nextStep')
        })

        this.store.dispatch('updateStepSetting', {
            setting: 'hideContinue',
            settingValue: !this.value,
            step: this.store.state.apply.currentRouteStep
        })
    },
    computed: {
        value: function () {
            return this.store.getters.fieldValue(this.name)
        },
    },
    methods: {
        inputSelected() {
            this.emitter.emit('nextStep')
        },
    },
}
</script>
